// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeSeparator_9aa3c50b {
  width: 15.667rem;
  margin-bottom: 1rem;
  border-top: 1px solid #dce1e5;
}
.timeInputToggleContainer_9aa3c50b {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
}
.timeStateButton_9aa3c50b {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.667rem;
}
.timeInputWrapper_9aa3c50b {
  width: fit-content;
  max-width: 100%;
  height: 32px;
  border: 1px solid #84919b;
  border-radius: 2px;
  text-align: center;
  padding: 4px 8px;
}
.timeInputWrapper_9aa3c50b .react-time-picker {
  border: none;
}
.timeInputWrapper_9aa3c50b .react-time-picker__wrapper {
  border: none;
}
.timeSwitch_9aa3c50b {
  margin-bottom: ;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timeSeparator": `timeSeparator_9aa3c50b`,
	"timeInputToggleContainer": `timeInputToggleContainer_9aa3c50b`,
	"timeStateButton": `timeStateButton_9aa3c50b`,
	"timeInputWrapper": `timeInputWrapper_9aa3c50b`,
	"timeSwitch": `timeSwitch_9aa3c50b`
};
export default ___CSS_LOADER_EXPORT___;
